import { useDispatch, useSelector } from "react-redux";
import { Box, Button, TextField } from "@mui/material";
import MaterialTable, { MTableAction } from "material-table";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { AddECMSExitReasonAction, UpdateECMSExitReasonAction, DeleteECMSExitReasonAction } from "../../../../../store/Employee/ECMS/Action";

const ExitReasonGrid = () => {
  const dispatch = useDispatch();
  const { exitReasonsLoading, exitReasonsData } = useSelector(
    (state) => state?.EmployeeReducer?.ECMSReducer
  );

  return (
    <Box>
      <MaterialTable
        isLoading={exitReasonsLoading}
        columns={[
          {
            title: "Reason",
            cellStyle: { padding: "5px 10px 0px 28px" },
            field: "exit_reason",
            validate: (rowData) => {
               if (rowData?.tableData && rowData?.tableData?.editing === "delete") {
                  return ""; 
              }
              if (!rowData?.exit_reason?.trim()) {
                return "Reason cannot be empty";
              }
              return "";
            },
            editComponent: (props) => {
              return (
                <Box sx={{ width: "95%" }}>
                  <TextField
                    required={true}
                    variant="standard"
                    fullWidth
                    value={props?.value}
                    onChange={(e) => props.onChange(e.target.value)}
                  />
                </Box>
              );
            },
          },
        ]}
        data={exitReasonsData || []}
        icons={{
          Add: () => (
            <Button
              variant="contained"
              className="mpl-primary-btn"
              style={{
                minWidth: 0,
                width: "82px",
                height: "35px",
                padding: "2px 12px",
                textTransform: "none",
              }}
              startIcon={<AddIcon />}
            >
              Add
            </Button>
          ),
          Edit: () => <EditIcon sx={{ color: "#637381" }} />,
          Delete: (props) => <DeleteIcon sx={{ color: props?.disabled ? "#bdbdbd" : "#637381"}} />,
        }}
        editable={{
          onRowAdd: (newRow) =>
            new Promise((resolve, reject) => {
              if (!newRow?.exit_reason?.trim()) {
                  return reject();
                }
              dispatch(
                AddECMSExitReasonAction({
                  ...newRow,
                })
              );
              setTimeout(() => resolve(), 500);
            }),
          onRowUpdate: (newRow, oldRow) =>
            new Promise((resolve, reject) => {
              if (!newRow?.exit_reason?.trim()) {
                  return reject();
                }
              dispatch(
                UpdateECMSExitReasonAction({
                  ...newRow,
                })
              );
              setTimeout(() => resolve(), 500);
            }),
          isDeletable: (rowData) => !rowData.is_default,
          onRowDelete: (selectedRow) =>
            new Promise((resolve, reject) => {
              dispatch(
                DeleteECMSExitReasonAction({
                  ...selectedRow,
                })
              );
              setTimeout(() => resolve(), 1000);
            }),
        }}
        options={{
          maxBodyHeight: "250px",
          minBodyHeight: "250px",
          rowStyle: { fontSize: "13px" },
          headerStyle: { padding: "5px 10px 5px 25px", fontWeight: "bold" },
          sorting: false,
          search: false,
          searchFieldAlignment: "right",
          searchAutoFocus: true,
          searchFieldVariant: "standard",
          filtering: false,
          paging: false,
          selection: false,
          actionsColumnIndex: -1,
          grouping: false,
          addRowPosition: "first",
        }}
        title={""}
        components={{
          Action: (props) => {
            const ActionComponent = props?.components?.Action || MTableAction;

            if (
              props?.action?.icon &&
              typeof props?.action?.icon === "function"
            ) {
              return (
                <Box
                  sx={{
                    "& .MuiIconButton-root": {
                      "&:hover": {
                        backgroundColor: "transparent",
                      },
                    },
                  }}
                >
                  <ActionComponent {...props} />
                </Box>
              );
            }
            return <ActionComponent {...props} />;
          },
        }}
      />
    </Box>
  );
};
export default ExitReasonGrid;
